import { Children, useEffect, useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useResetInputs } from "src/Contexts/hooks/useResetInputs";

import {
  ModalDeleteCore,
  TableRowCore,
  TableCore,
  TdCore,
} from "src/Pages/components";
import {
  AddIcon,
  EditIcon,
  DeleteForeverIcon,
  CurrencyExchangeIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";

import { UseGetByIdCampaign } from "./Hooks/UseGetByIdContratos";
import { useHttpTableCampaign } from "./Hooks/useHttpTableCampaign";
import { THeadCampaign } from "./THead";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { ModalCampaign } from "../Form";
import { useContextCampaign } from "src/Contexts/Campaign/ContextCampaign";
import {
  FormControlLabel,
  LinearProgress,
  Typography,
  Box,
} from "@mui/material";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import { IOSSwitch } from "./Components/ToggleStart";
import { InfoModalCampaign } from "../Components/InfoModalCampaign";
import { useNavigate } from "react-router";
import { objCampaignFlowsStatus } from "../../../CampaignInternal/Components/HelpersObjs/HelpersObjs";
import { api } from "src/shared/setup/API/api";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { RotatingCachedIcon } from "src/Pages/components/Icons/RotatingCachedIcon";

export const TableCampaign = () => {
  const { resetInputs } = useResetInputs();
  const { handleGet } = useHttpTableCampaign();
  const { listCampaign } = useContextCampaign();
  const { handleGetById } = UseGetByIdCampaign();
  const { handleGetAlert } = useLayoutMainContext();

  const navigate = useNavigate();

  const [openModalContracts, setOpenModalContracts] = useState(false);

  const {
    setNameSearch,
    itensPerPage,
    currentPage,
    setAttTable,
    nameSearch,
    attTable,
    setId,
    loadingTable,
  } = useConfigPageContext();

  const handleGetIdToEdit = (id: string) => {
    resetInputs();
    setOpenModalContracts(true);
    setId(id);
    handleGetById(id);
  };

  useEffect(() => {
    handleGet();

    const interval = setInterval(() => {
      handleGet();
    }, 30000 * 2); // 30s * 2 = 60s
    return () => clearInterval(interval);
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/campaign" });

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    api
      .patch(`/campaign/change-status/${id}`, {
        status: event.target.checked,
      })
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable(!attTable);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return (
    <TableCore
      Modals={
        <>
          <ModalCampaign
            openModal={openModalContracts}
            setOpenModal={setOpenModalContracts}
          />

          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja campanha ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={handleDelete}
            titleSecondary="Esta ação é irreversível. Após deletar, não será possível recuperar a campanha. Não é permitido excluir campanhas que já executaram algum fluxo."
          />
        </>
      }
      THead={<THeadCampaign />}
      modalInfo={{
        children: <InfoModalCampaign />,
        title: "Tutorial: Campanhas",
      }}
      qtdList={listCampaign.length}
      setNameSearch={setNameSearch}
      cardAdd={{
        buttons: [
          <RotatingCachedIcon
            onClick={() => setAttTable((item) => !item)}
            isLoading={loadingTable}
            tooltipTitle="Recarregar a página"
            iconButtonSx={{ mr: 1.5, ml: -2 }}
          />,
          <ButtonCore
            startIcon={<AddIcon />}
            title="Criar campanha"
            size="small"
            onClick={() => setOpenModalContracts(true)}
          />,
        ],
      }}
    >
      {Children.toArray(
        listCampaign.map((item) => {
          return (
            <TableRowCore sxStyle={{ height: "80px" }}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <CurrencyExchangeIcon fontSize="small" />,
                        title: "Ver campanha",
                        onClick: () => {
                          navigate(`/campaign/${item.id}`);
                        },
                      },

                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        onClick: () => {
                          handleGetIdToEdit(String(item.id));
                        },
                      },
                      {
                        title: "Excluir",
                        onClick: () => {
                          setIdModalDelete(item.id);
                          setOpenModalDelete(true);
                        },
                        icon: <DeleteForeverIcon fontSize="small" />,
                      },
                    ]}
                  />
                }
              />

              <TdCore
                textAlign="center"
                values={
                  <FormControlLabel
                    value={item.isActive}
                    control={
                      <IOSSwitch
                        disabled={item.status === "COMPLETED"}
                        sx={{ ml: 4, mb: 0.8 }}
                        onChange={(e) => handleChange(e, item.id)}
                        inputProps={{ "aria-label": "controlled" }}
                        checked={item.isActive}
                      />
                    }
                    label=""
                  />
                }
                subTitle={
                  <>
                    {item.status === "IN_PROGRESS" ? (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <LinearProgress
                          sx={{ width: "80px", margin: "0 auto" }}
                        />
                        <Typography>
                          {objCampaignFlowsStatus[item.status].text}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography sx={{ fontSize: "13px" }}>
                        {objCampaignFlowsStatus[item.status].text}
                      </Typography>
                    )}
                  </>
                }
              />

              <TdCore
                values={item.title}
                textAlign="left"
                subTitle={item.description}
              />
              <TdCore
                values={item.groupLeads.title}
                textAlign="left"
                subTitle={`Total de Leads: ${item.groupLeads._count.GroupManyLeads}`}
              />

              <TdCore
                textAlign="left"
                values={item.instancesWhats.title}
                subTitle={cpfOurCnpj({
                  text: item.instancesWhats.number
                    ? item.instancesWhats.number
                    : "",
                  type: "phone",
                })}
              />

              <TdCore values={`${item.flowCurrency} / ${item.flowTotal}`} />

              <TdCore
                textAlign="center"
                values={
                  item.status === "COMPLETED"
                    ? "Processo Finalizado"
                    : item.flowTotal === item.flowCurrency
                    ? `${FormatDateBR(
                        item.flows[item.flowCurrency - 1].date
                      )} as ${item.flows[item.flowCurrency - 1].hour}`
                    : `${FormatDateBR(
                        item.flows[item.flowCurrency]?.date
                      )} as ${item.flows[item.flowCurrency]?.hour}`
                }
                sxStyle={{
                  fontWeight: "600",
                  color: (theme) => theme.custom.color.money,
                  borderRadius: "12px",
                  border: "1px solid gray",
                }}
              />

              <TdCore values={FormatDateBR(item.createdAt)} />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
